import { render, staticRenderFns } from "./SetAppNotification.vue?vue&type=template&id=5cae1af5&scoped=true"
import script from "./SetAppNotification.vue?vue&type=script&lang=js"
export * from "./SetAppNotification.vue?vue&type=script&lang=js"
import style0 from "./SetAppNotification.vue?vue&type=style&index=0&id=5cae1af5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cae1af5",
  null
  
)

export default component.exports